import * as React from 'react';
import { useState, useEffect } from 'react';
import styles from './pagesTransfer.module.scss';

import { Toast } from 'antd-mobile-v5';

import { ApiCore } from '../api/index';
import utils from '../utils/utils';
const api = new ApiCore();


const PfizerRegister = (props: any) => {


    // 小程序url
    const [code, setCode] = useState<any>('');

    useEffect(() => {
        document.title = '加载中...';
        Toast.show('跳转中...');
        window.location.href = `https://wxaurl.cn/${props.match?.params?.code}`;
    }, [])


    return (
        <div className={styles.pages_transfer}>
        </div>
    )
}

export default PfizerRegister